import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import { WidgetContact } from '../modules/ingenie/WidgetContact';
import { Breadcrumb } from '../components/2.0version/breadcrumb/Breadcrumb';
import { URLS } from '../../constants';
import * as styles from './contact.module.scss';
import { ContactTranslationQuery } from '../../graphql-types';
import { SEO } from '../components/2.0version/seo/Seo';

interface IContactPageProps {
  data: ContactTranslationQuery;
}

const handleMessage = (e: any) => {
  if (e.origin !== 'https://resa-tours.ingenie.fr') return;
  if (e.delta === 'gtagFormulaireContact') {
    window.gtag('event', 'envoi_formulaire_contact', {
      event_category: 'prospect',
      event_label: 'page_contact',
    });
  }
};

const ContactPage = ({ data }: IContactPageProps) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('message', handleMessage);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('message', handleMessage);
      }
    };
  }, []);

  return (
    <>
      <SEO />
      <Breadcrumb
        pathsInput={[
          { label: data.sanityTranslations?._rawContactPageName, url: URLS.contact.url },
        ]}
      />
      <div className={styles.contactWrapper}>
        <WidgetContact />
      </div>
    </>
  );
};

export const QUERY = graphql`
  query contactTranslation {
    sanityTranslations {
      _rawContactPageName
    }
  }
`;

export default ContactPage;
